export default "__VITE_ASSET__83f6c209__"